import React, {useCallback, useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router";
import moment from "moment";
import Modal from '../../components/Modal';
import {useTranslation} from 'react-i18next';
import {AxiosError} from 'axios';
import {Location} from 'history';
import client from 'lib/CommonApi/client';
import {
	callAlertWeb,
	clickGmoneypayDetailWeb,
	clickIncomeDeductionWeb,
	hideProgressWeb,
	showProgressWeb
} from 'common/appInterface';
import {inquiryStaticData} from "../../api/SelfCommonAPI";
import {CardProductCode} from "../../constants/Card";

const CardManage: React.FC<CardManageProps> = ({
                                                 cardInfo,
                                                 callbackReload,
                                                 swiperIndex,
                                                 linkOpenMenu,
                                                 nonInoutTotalBalance,
                                                 nonInoutInfoDetail,
                                                 callNonInoutInfo,
                                                 incomeDeductionAppVersion,
                                                 cardIncomeDeductionVersionApi,
                                                 callMonthlyFeeHistory,
                                                 monthlyFeeHistory,
                                                 setReissueModal,
                                                 swiperTabChangeEventHandle
                                               }) => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** 다국어처리 */
  const { t } = useTranslation();

  const [isPauseModal, setPauseModal] = useState(false);
  const [isLostAcciModal, setLostAcciModal] = useState(false);
  const [isLostCnclModal, setLostCnclModal] = useState(false);
  const [isTerminalModal, setTerminalModal] = useState(false);

  const [cardWithdrawAmount, setCardWithdrawAmount] = useState<number>(0);
  const [debitState, setDebitState] = useState<CardDebitState | null>(null);

  const [isLinkMenu, setLinkMenu] = useState(false);

  /** 사고등해제 호출 */
  const callAccident = useCallback(async (code: string) => {
    showProgressWeb();
    await client.post("/api/app/accident/cardAccident", { ...location.state.query, alternativeCardNo: cardInfo.alternativeCardNo, cardAccidentCode: code, userLostDate: (code === "111" ? moment().format("YYYYMMDD") : null) }).then((response) => {
      // 정상
      if (response.data.code === "00") {
        // 일시정지
        if (code.startsWith("07")) {
          setPauseModal(true);
        }
        // 분실신고
        else if (code.startsWith("111")) {
          setLostAcciModal(false);
          callbackReload();
        }
        else {
          callbackReload();
        }
      }
      else {
        callAlertWeb("ERROR", response.data.code, response.data.message);
      }
    }).catch((e: AxiosError) => {
      callAlertWeb("ERROR", "99", e.message);
    }).finally(() => {
      hideProgressWeb();
    });
  }, [location, cardInfo, callbackReload]);

  /** 일시정지 모달닫기 */
  const closePauseModal = useCallback(() => {
    setPauseModal(false);
    callbackReload();
  }, [callbackReload]);

  /** 분실신고 모달닫기 */
  const closeLostAcciModal = useCallback(() => {
    setLostAcciModal(false);
    callbackReload();
  }, [callbackReload]);

  /** 분실신고해제 모달닫기 */
  const closeLostCnclModal = useCallback(() => {
    setLostCnclModal(false);
    callbackReload();
  }, [callbackReload]);

  /** 카드해지 모달닫기 */
  const closeTerminalModal = useCallback(() => {
    setTerminalModal(false);
    callbackReload();
  }, [callbackReload]);

  /**
   * dhbyun
   * 카드 자동 출금 금액 조회
   */
  const inquiryStaticDataApi = useCallback(
    async () => {
      await inquiryStaticData("CARD_WITHDRAW_ADDITIONAL_AMT", location)
        .then((res) => {
          if (res.data.resData) {
            setCardWithdrawAmount(res.data.resData.data);
          }
        }).catch((e: AxiosError) => {
          callAlertWeb("ERROR", "99", e.message);
        });
    },
    [location]
  );

  /** 카드출금동의여부조회 */
  const callDebitState = useCallback(async () => {
    await client.get('/api/app/manage/debit/state', {
      params: {
        ...location.state.query,
        alternativeCardNo: cardInfo.alternativeCardNo
      }
    }).then(response => {
      setDebitState(response.data.response);
      if (linkOpenMenu) setLinkMenu(true);
    }).catch((e: AxiosError) => {
      callAlertWeb('ERROR', '99', e.message);
    });
  },
      [cardInfo.alternativeCardNo, location.state.query, linkOpenMenu, setLinkMenu]
  );

  const clickMonthlyFeeHistory = useCallback(
      async () => {
    navigate("/manage/monthlyFee/history", {
      state: {
        query: location.state.query,
        info: cardInfo,
        swiperIndex: swiperIndex,
        tabIndex: "3",
        userInfo: debitState,
        storage: {
          monthlyFeeHistory: monthlyFeeHistory,
          nonInoutTotalBalance: nonInoutTotalBalance,
          nonInoutInfoDetail: nonInoutInfoDetail
        },
        linkOpenMenu : (linkOpenMenu)? 'main':''
      }
    })
  }, [navigate, location.state.query, cardInfo, swiperIndex, debitState, monthlyFeeHistory, nonInoutTotalBalance, nonInoutInfoDetail, linkOpenMenu]);

  const clickCardDebit = useCallback(
      async () => {
    navigate("/manage/card/debit", {
      state: {
        query: location.state.query,
        info: cardInfo,
        swiperIndex: swiperIndex,
        tabIndex: "3",
        staticInfo: {
          cardWithdrawAdditionalAmount: cardWithdrawAmount
        },
        userInfo: debitState,
        linkOpenMenu : (linkOpenMenu)? 'main':''
      }
    });
  }, [navigate, location.state.query, cardInfo, swiperIndex, cardWithdrawAmount, debitState, linkOpenMenu]);

  const clickPasswordChange = useCallback(
      async () => {
        navigate("/manage/password/change",
            {
              state: {
                 query: location.state.query
                ,info: cardInfo
                ,swiperIndex: swiperIndex
                ,tabIndex: "3"
                ,linkOpenMenu : (linkOpenMenu)? 'main':''
              }
            }
        )
      }, [navigate, location.state.query, cardInfo, swiperIndex, linkOpenMenu]);

  const clickFreeze = useCallback(
      async () => {
        navigate("/manage/card/freeze",
            {
              state: {
                 query: location.state.query
                ,info: cardInfo
                ,swiperIndex: swiperIndex
                ,tabIndex: "3"
                ,linkOpenMenu : (linkOpenMenu)? 'main':''
              }
            }
        )
      },
      [navigate, location.state.query, cardInfo, swiperIndex, linkOpenMenu]
  );

  const clickMonthlyFeeDebit = useCallback(
      async () => {
        navigate("/manage/monthlyFee/debit", {
          state: {
            query: location.state.query,
            info: cardInfo,
            swiperIndex: swiperIndex,
            tabIndex: "3",
            staticInfo: {
              cardWithdrawAdditionalAmount: cardWithdrawAmount
            },
            userInfo: debitState
            ,linkOpenMenu : (linkOpenMenu)? 'main':''
          }
        })
      },
      [navigate, location.state.query, cardInfo, swiperIndex, cardWithdrawAmount, debitState, linkOpenMenu]
  );

  const callbackIncomeDeductionWeb = useCallback(
      async () => {
        clickIncomeDeductionWeb();
      },[]
  );

  //카드 월회비 유형
  const clickCardMonthlyFeeTypeView = useCallback(
      async () => {
        navigate("/manage/card/monthlyFeeType",
            {
              state: {
                query: location.state.query
                ,info: cardInfo
                ,apply: {
                  callPage:'cardManage'
                }
                ,from: location.pathname
                ,swiperIndex: swiperIndex
                ,tabIndex: "3"
                ,linkOpenMenu : (linkOpenMenu)? 'main':''
              }
            }
        );
      },
      [navigate, location, cardInfo, swiperIndex, linkOpenMenu],
  );

  const viewLinkMenu = useCallback(
      async () => {
        switch (linkOpenMenu) {
          case "monthlyFeeHistory" :
            if (monthlyFeeHistory.length !== 0 || nonInoutTotalBalance !== 0) clickMonthlyFeeHistory();
            break;
          case "monthlyFeeType" :
            clickCardMonthlyFeeTypeView();
            break;
          case "autoDebit" :
            if (cardInfo.cardStatusCode !== '22') clickCardDebit();
            break;
          case "password" :
            if (cardInfo.cardStatusCode !== "22") clickPasswordChange();
            break;
          case "freeze" :
            if (cardInfo.cardStatusCode !== '22') clickFreeze();
            break;
          case "report" :
            if (cardInfo.cardStatusCode === '22') setLostCnclModal(true);
            else setLostAcciModal(true);
            break;
          case "reissue" :
            if (cardInfo.reissueReceiveYn === 'N') setReissueModal(true);
            break;
          case "terminate" :
            setTerminalModal(true);
            break;
          case "monthlyFeeDebit" :
            clickMonthlyFeeDebit();
            break;
          case "yearEndTaxSettlement" :
            if ((location.state.query.apiVersion != null && incomeDeductionAppVersion != null)
              && (parseInt(location.state.query.apiVersion) >= incomeDeductionAppVersion!))
              callbackIncomeDeductionWeb();
            break;
        }
      },[clickMonthlyFeeHistory, monthlyFeeHistory.length, nonInoutTotalBalance, clickCardMonthlyFeeTypeView,
        cardInfo, linkOpenMenu, clickCardDebit, clickFreeze, setLostCnclModal, setLostAcciModal, setReissueModal, setTerminalModal,
        clickMonthlyFeeDebit, clickPasswordChange, location, incomeDeductionAppVersion, callbackIncomeDeductionWeb]);

  // 최초실행
  useEffect(() => {
    console.log(cardInfo);
    console.log(location.state.query);

    inquiryStaticDataApi();
    cardIncomeDeductionVersionApi();
    callDebitState();
    callMonthlyFeeHistory(cardInfo);
    callNonInoutInfo();

    // Swiper Height Resize
    swiperTabChangeEventHandle();

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isLinkMenu) {
      viewLinkMenu();
      setLinkMenu(false);
    }
  }, [isLinkMenu, viewLinkMenu]);

  const clickCardNumberView = () => {
    navigate("/manage/pincode/verify",
        {
          state: {
                   query: location.state.query
                  ,apply: {
                             alternativeCardNo: cardInfo.alternativeCardNo
                            ,callPage:'cardManage'
                          }
                  ,from: location.pathname
                  ,swiperIndex: swiperIndex
                  ,tabIndex: "3"
                }
        }
    );
  }

  useEffect(() => {
    if (linkOpenMenu === "monthlyFeeHistory") {
      if (monthlyFeeHistory.length !== 0 || nonInoutTotalBalance !== 0) {
        clickMonthlyFeeHistory();
      }
    }
  }, [linkOpenMenu, monthlyFeeHistory, nonInoutTotalBalance, clickMonthlyFeeHistory]);

  return (
    <section className="contents myPageSetting">
      <div className="inner" style={{paddingBottom: 75}}>
        <div className="settingListWrap clfix">
          <dl className="settingList">
            <dd>
              <button type="button" onClick={() => clickCardNumberView()}>
                <span className="tit">{t("SERV01.button12")}</span>
                <span className="account">{cardInfo.cardNo}</span>
              </button>
            </dd>
            <dd>
              <button type="button" onClick={() => clickGmoneypayDetailWeb()}>
                <span className="tit">{t("SERV01.button01")}</span>
                <span className="account">GmoneyPay Account-{cardInfo.accountNo.slice(-4)}</span>
              </button>
            </dd>
            {Number(cardInfo.cardProductCode) === CardProductCode.WelcomeCard ||
                (<dd>
                  <button type="button" onClick={() => clickCardMonthlyFeeTypeView()} disabled={Number(cardInfo.cardProductCode) === CardProductCode.DirectCard}>
                    <span className="tit">{t("SERV01.button17")}</span>
                  </button>
                </dd>)
            }
            {Number(cardInfo.cardProductCode) === CardProductCode.WelcomeCard ||
                (<dd>
                  <button type="button" onClick={() => clickMonthlyFeeHistory()}
                          disabled={monthlyFeeHistory.length === 0 && nonInoutTotalBalance === 0}
                  >
                    <span className="tit">{t("SERV01.button15")}</span>
                  </button>
                </dd>)
            }
            <dd>
              <button type="button" disabled={cardInfo.cardStatusCode === "22"} onClick={() => clickCardDebit()}>
                <span className="tit">{t("SERV01.button11")}</span>
              </button>
            </dd>
            <dd><button type="button" disabled={cardInfo.cardStatusCode === "22"} onClick={() => clickPasswordChange()}><span className="tit">{t("SERV01.button02")}</span></button></dd>
            <dd>
              <button type="button" onClick={() => clickFreeze()} disabled={cardInfo.cardStatusCode === "22"}>
                <span className="tit">{t("SERV01.button03")}</span></button></dd>
            {/*<dd className="inChkbox">*/}
            {/*  <div className={cardInfo.cardStatusCode === "22" ? "disabled" : ""}>*/}
            {/*    <span className="tit">{t("SERV01.button03")}</span>{cardInfo.cardStatusCode === "21" && <span className="freeze">({t("SERV01.button03_1")})</span>}*/}
            {/*    <div className="toggleBox">*/}
            {/*      <div className="inputBox">*/}
            {/*        <input type="checkbox" id={`${cardInfo.alternativeCardNo}_toggle02`} checked={isPause} onChange={() => callAccident(cardInfo.cardStatusCode === "21" ? "079" : "071")} disabled={cardInfo.cardStatusCode === "22"} />*/}
            {/*        <span></span>*/}
            {/*        <label htmlFor={`${cardInfo.alternativeCardNo}_toggle02`}></label>*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</dd>*/}
            {cardInfo.cardStatusCode !== "22" &&
              <dd><button type="button" onClick={() => setLostAcciModal(true)}><span className="tit">{t("SERV01.button04")}</span></button></dd>
            }
            {cardInfo.cardStatusCode === "22" &&
              <dd><button type="button" onClick={() => setLostCnclModal(true)}><span className="tit">{t("SERV01.button05")}</span></button></dd>
            }
            <dd><button type="button" onClick={() => setReissueModal(true)} disabled={cardInfo.reissueReceiveYn === 'Y' || cardInfo.useYn !== "Y"}><span className="tit">{t("SERV01.button06")}</span></button></dd>
            <dd><button type="button" onClick={() => setTerminalModal(true)}><span className="tit">{t("SERV01.button07")}</span></button></dd>
            {Number(cardInfo.cardProductCode) === CardProductCode.WelcomeCard ||
                (<dd>
                  <button type="button" onClick={() => clickMonthlyFeeDebit()}>
                    <span className="tit">{t("SERV01.button13")}</span>
                  </button>
                </dd>)
            }
            { ((location.state.query.apiVersion != null && incomeDeductionAppVersion != null)
              && (parseInt(location.state.query.apiVersion) >= incomeDeductionAppVersion!)) && (
              <dd>
                <button type="button" onClick={() => clickIncomeDeductionWeb()}>
                  <span className="tit">{t("SERV01.button14")}</span>
                </button>
              </dd>
            )}
          </dl>
        </div>
      </div>
      {/* 일시정지 */}
      <Modal isOpen={isPauseModal} contentLabel="modal" onRequestClose={closePauseModal} className="popTyLayer2" overlayClassName="dim" closeTimeoutMS={0}>
        <p className="message">{cardInfo.cardStatusCode === "21" ? t("SERV03.popup05") : t("SERV03.popup02")}</p>
        <dl>
          {/*<dt>{cardInfo.cardStatusCode === "21" ? t("SERV03.popup06") : t("SERV03.popup03")}</dt>*/}
          <dd><span>{cardInfo.cardNo}</span></dd>
        </dl>
        <div className="btnWrapTy02">
          <button type="button" className="btnPrimaryTy01" onClick={closePauseModal}><span>{t("COMMON.button.confirm")}</span></button>
        </div>
      </Modal>
      {/* 분실신고 등록 */}
      <Modal isOpen={isLostAcciModal} contentLabel="modal" onRequestClose={closeLostAcciModal} className="popTyLayer2" overlayClassName="dim" closeTimeoutMS={500}>
        <p className="message">{t("SERV04.popup02")}</p>
        <p className="subTxt mgt20">{t("SERV04.popup04")}</p>
        <p className="subTxt">{t("SERV04.popup05")}</p>
				{cardInfo.membershipFeeCode !== "0" && (
        	<p className="subTxt">{t("SERV04.popup07")}</p>
				)}
        <p className="messageARS">{t("SERV04.popup06")}</p>
        <div className="btnWrapTy02">
          <button type="button" className="btnPrimaryTy01" onClick={closeLostAcciModal}><span>{t("COMMON.button.no")}</span></button>
          <button type="button" className="btnPrimaryTy03" onClick={() => callAccident("111")}><span>{t("COMMON.button.yes")}</span></button>
        </div>
      </Modal>
      {/* 분실신고 해제 */}
      <Modal isOpen={isLostCnclModal} contentLabel="modal" onRequestClose={closeLostCnclModal} className="popTyLayer2" overlayClassName="dim" closeTimeoutMS={500}>
        <p className="message">{t("SERV05.popup02")}</p>
        <p className="subTxt mgt20">{t("SERV05.popup03")}</p>
        <p className="messageARS">{t("SERV05.popup06")}</p>
        <div className="btnWrapTy02">
          <button type="button" className="btnPrimaryTy03" onClick={closeLostCnclModal}><span>{t("COMMON.button.no")}</span></button>
          <button type="button" className="btnPrimaryTy01" onClick={() => navigate("/manage/card/verify/lostCancel", { state: { query: location.state.query, info: cardInfo, swiperIndex: swiperIndex, tabIndex: "3" }})}><span>{t("COMMON.button.yes")}</span></button>
        </div>
      </Modal>
      {/* 카드해지 */}
      <Modal isOpen={isTerminalModal} contentLabel="modal" onRequestClose={closeTerminalModal} className="popTyLayer2" overlayClassName="dim" closeTimeoutMS={500}>
        <p className="message">{t("SERV07.popup01")}</p>
        <p className="subTxt mgt20">{t("SERV07.popup02")}</p>
        <p className="messageARS">{t("SERV07.popup03")}</p>
        <div className="btnWrapTy02">
          <button type="button" className="btnPrimaryTy01" onClick={closeTerminalModal}><span>{t("COMMON.button.ok")}</span></button>
        </div>
      </Modal>
    </section>
  );
};

export default CardManage;